/**
 * Global 401 handler. The server session cookie can outlive the Google refresh
 * token; when that happens API calls return 401 while the app still thinks it is
 * logged in — resulting in a blank screen. Here we intercept any 401, clear the
 * stale session and send the user back to login so the app "realises" it is out.
 */
export default defineNuxtPlugin(() => {
    const { clear, loggedIn } = useUserSession();
    const toast = useToast();
    const router = useRouter();

    // Wrap the global $fetch (used by $fetch and useFetch) with an error hook.
    globalThis.$fetch = $fetch.create({
        onResponseError: async ({ request, response }) => {
            if (response?.status !== 401) return;

            const url = typeof request === 'string' ? request : request?.url;
            // Ignore the session endpoints themselves to avoid redirect loops.
            if (url?.includes('/api/_auth/')) return;

            if (loggedIn.value) {
                await clear();
                toast.addToast({
                    id: 'session-expired',
                    title: 'Session expired',
                    message: 'Please log in again.',
                    severity: 'warning',
                });
            }

            // Only redirect if we're not already on a public page.
            const publicPages = ['/login', '/about', '/'];
            if (!publicPages.includes(router.currentRoute.value.path)) {
                await navigateTo('/');
            }
        },
    });
});
